import DefaultConfig from "../DefaultConfig";
import { VUE_APP_UI_URL } from "../../environment";

import { getLoginRouteForTimeout } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default class Service {
  // Will be used by this service for making API calls
  axiosIns = null;

  // Config <= Will be used by this service
  Config = { ...DefaultConfig };

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // For Refreshing Token
  subscribers = [];

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns;
    this.Config = { ...this.Config, ...jwtOverrideConfig };

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      (config) => {
        // Get token from localStorage
        const accessToken = this.getToken();

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.Config.tokenType} ${accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      (response) => {
        if (response.status === 401) {
          // unauthorized
          let path = pURL.parse(response.config.url).path;
          const inApi = new String(path).split("/")[1];
          if (inApi === "api") {
            console.log("Unauthorized API access: " + path);
          }
        }

        return response;
      },
      (error) => {
        try {
          if (error.response.status == 401 || error.response.status == 403) {
            this.$router.replace(getLoginRouteForTimeout()).then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "เซสชั่นหมดอายุ",
                  icon: "AlertCircleIcon",
                  variant: "warning",
                  text: "กรุณาเข้าสู่ระบบอีกครั้ง",
                },
              });
            });
          }
        } catch (error) {
          localStorage.clear();
          //router.push("/login");
          window.location.href = VUE_APP_UI_URL + '/login';
        }

        /** Do something with response error */
        /*if (error.response.status == 401 || error.response.status == 403) {
          this.$router.replace(getLoginRouteForTimeout()).then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "เซสชั่นหมดอายุ",
                icon: "AlertCircleIcon",
                variant: "warning",
                text: "กรุณาเข้าสู่ระบบอีกครั้ง",
              },
            });
          });
        }*/
        return Promise.reject(error);
      }
    );
  }

  getToken() {
    return localStorage.getItem(this.Config.storageTokenKeyName);
  }

  getRefreshToken() {
    return localStorage.getItem(this.Config.storageRefreshTokenKeyName);
  }

  //

  getDropdownDefault() {
    return this.axiosIns.get(this.Config.getDefaultDropdown);
  }

  getCustomerDropdown() {
    return this.axiosIns.get(this.Config.getCustomerDropdown);
  }

  getDepartmentDropdown() {
    return this.axiosIns.get(this.Config.getDepartmentDropdown);
  }

  getAdminPageDropdown() {
    return this.axiosIns.get(this.Config.getAdminPageDropdown);
  }

  getReqFormDropdown() {
    return this.axiosIns.get(this.Config.getReqFormDropdown);
  }

  getAllDropdownForCustomerForm() {
    return this.axiosIns.get(this.Config.getCustomerFormDropdown);
  }
}
